import { useNavigate } from "react-router-dom"
import "./AboutPage.css"

const AboutPage = () => {
  const navigate = useNavigate()
  return (
    <div className="page-container">
      
      {/* Main Content */}
      <main className="main-content">
        <h2 className="page-title">About Corporate NRIs</h2>
        <p className="page-description">
          Welcome to Corporate NRIs, your trusted digital platform designed to simplify life for Non-Resident Indians
          (NRIs) worldwide.
        </p>

        <div className="sections-container">
          {/* Who We Are */}
          <section className="content-section">
            <h3 className="section-title">Who We Are</h3>
            <p className="section-text">
              Corporate NRIs is more than just a service platform; it's a vibrant community built for NRIs, by NRIs.
              Founded with a vision to empower working professionals, families, students, and retirees living abroad, we
              provide a centralized hub where you can access verified services, share resources, and connect with others
              who understand your journey. Whether you're relocating, traveling, or seeking local support, we're here to
              make your experience effortless and reliable.
            </p>
          </section>

          {/* What We Do */}
          <section className="content-section">
            <h3 className="section-title">What We Do</h3>
            <p className="section-text">
              Our platform offers a wide range of curated services tailored to the NRI lifestyle, including:
            </p>
            <ul className="services-list">
              <li>
                <strong>Home Rentals</strong>: Secure verified rental properties in India and abroad with
                corporate-to-corporate trust.
              </li>
              <li>
                <strong>Car Buying & Selling</strong>: Connect with verified NRI buyers and sellers for seamless vehicle
                transfers.
              </li>
              <li>
                <strong>Vouchers & Deals</strong>: Access exclusive discounts on travel, shopping, healthcare, and more.
              </li>
              <li>
                <strong>Travel Companions</strong>: Find trusted companions for your journeys, perfect for seniors or
                solo travelers.
              </li>
              <li>
                <strong>Medical Support</strong>: Get reliable healthcare guidance and connections to trusted providers.
              </li>
              <li>
                <strong>Commerce & Trade</strong>: Buy, sell, or exchange goods within our secure NRI marketplace.
              </li>
              <li>
                <strong>Visa & Legal Services</strong>: Simplify visa processing and legal experiences with fellow NRI assistance.
              </li>
              <li>
                <strong>Ask & Answer Platform</strong>: Post questions or offers and receive responses from our verified
                community.
              </li>
            </ul>
            <p className="section-text">
              With a simple post-and-respond model, we route your needs to the right people—whether it's a fellow NRI or
              a vetted service provider—ensuring quick, transparent, and dependable solutions.
            </p>
          </section>

          {/* Why Choose Us */}
          <section className="content-section">
            <h3 className="section-title">Why Choose Us</h3>
            <ul className="features-list">
              <li>
                <strong>Community-Driven</strong>: Built on trust, our platform fosters peer-to-peer support among NRIs.
              </li>
              <li>
                <strong>Verified & Secure</strong>: Every user and listing is vetted to ensure reliability and safety.
              </li>
              <li>
                <strong>Tailored for NRIs</strong>: Our services are designed to address the specific needs of the NRI
                diaspora.
              </li>
              <li>
                <strong>Global Reach, Local Impact</strong>: Connecting millions of NRIs across geographies with local
                expertise.
              </li>
              <li>
                <strong>User-Friendly</strong>: Our intuitive interface makes it easy to post, connect, and resolve your
                needs.
              </li>
            </ul>
          </section>

          {/* Our Vision */}
          <section className="content-section">
            <h3 className="vision-title">Our Vision</h3>
            <p className="section-text">
              We envision a world where NRIs feel connected, supported, and confident, no matter where they are. By
              bridging distances and building trust, Corporate NRIs aims to be the go-to platform for every NRI seeking
              convenience, community, and confidence in their daily lives.
            </p>
          </section>

          {/* Call to Action */}
          <section className="cta-section">
            <h3 className="cta-title">Join Us Today</h3>
            <p className="cta-description">
              Be part of a growing community that's redefining how NRIs live, work, and connect. Whether you're seeking
              a service, offering help, or simply exploring, Corporate NRIs is your home away from home.
            </p>
            <button type="button" onClick={() => navigate("/signUp")} className="cta-button">
              Sign Up Now
            </button>
          </section>
        </div>
      </main>

    </div>
  )
}

export default AboutPage
